import React, { useState } from "react";

import SoftBox from "../../../components/SoftBox";
import SoftProfile from "../../../components/ProfilePictures/SoftProfile";
import SoftTypography from "../../../components/SoftTypography";

import AccountButton from "./components/AccountButton";

import useIntegrationsData from "./hooks/useIntegrationsData";
import { GET_IMAGE } from "../../../helpers/images";
import { GMB_LOGO_URL } from "../../../constants/branding";

const MAX_APPS = 2;

const IntegratedAccounts = () => {
  const { isLoading, connectedApps } = useIntegrationsData();
  const [isMaxApps, setIsMaxApps] = useState(true);

  const commonTitleStyles = {
    fontFamily: "DM Sans",
    fontWeight: 500
  }  

  return (
    <SoftBox
      sx={{
        "& h4": {
          ...commonTitleStyles,
          fontSize: "18px",
          lineHeight: "28px",
          color: "#000"
        },
        "& h5": {
          ...commonTitleStyles,
          fontSize: "12px",
          lineHeight: "18px",
          color: "#6C757D"
        },
      }}
    >
      {(!isLoading && connectedApps?.length === 0) &&
        <SoftTypography variant="h5">
          No connected apps
        </SoftTypography>
      }

      {(!isLoading && connectedApps?.length > 0) &&
        connectedApps?.map((app, index) => (
          (isMaxApps && index + 1 > MAX_APPS)
            ? null
            : <div
                key={app._id}
                className="rounded-xl border border-gray-200 p-3 sm:p-3.5 mb-2 sm:mb-2.5 flex items-center justify-between gap-2"
              >
                {/** Integrated app Logo and Name */}
                <div className="flex items-center gap-2.5 min-w-0">
                  <SoftProfile
                    src={GET_IMAGE(app.logo) || GMB_LOGO_URL}
                    name={app.name}
                    alt={app.code}
                    sx={{
                      borderRadius: "8px",
                      border: "1px solid #E9ECEF",
                      background: "transparent",
                      width: "32px",
                      height: "32px"
                    }}
                  />

                  <span className="text-sm font-semibold text-gray-900 truncate">
                    {app.name}
                  </span>
                </div>

                {/** Connected pill */}
                <span className="flex items-center gap-1 px-2.5 py-1 rounded-full bg-green-50 text-green-700 text-xs font-semibold flex-shrink-0">
                  ✓ Connected
                </span>
              </div>
      ))}

      {/** See All button */}
      {(!isLoading && connectedApps?.length > 1) &&
        <SoftBox sx={{ display: "flex", justifyContent: "flex-end", marginTop: "8px" }}>
          <AccountButton
            variant="text"
            onClick={() => setIsMaxApps(prev => !prev)}
            sx={{
              color: "#7928CA !important",
              textTransform: "capitalize",
              fontSize: "14px !important",
              padding: "6px 4px",
              lineHeight: "20px",
              border: "none",
            }}
          >
            See all
          </AccountButton>
        </SoftBox>
      }
    </SoftBox>
  );
};

export default IntegratedAccounts;
